import { defineCapability } from 'nest/capabilities';
import { args } from 'nest/common/args';

export const DELETE_GLOBAL_STYLES_CAP = defineCapability({
  name: 'DELETE_GLOBAL_STYLES_CAP' as const,
  args: {
    by: args.or(args.literal('selector'), args.literal('persistenceId')),
    value: args.string(),
    mode: args.or(args.literal('session'), args.literal('indefinite')),
  },
});
